import { render, staticRenderFns } from "./matched.vue?vue&type=template&id=c021e9e6"
import script from "./matched.vue?vue&type=script&lang=js"
export * from "./matched.vue?vue&type=script&lang=js"
import style0 from "./matched.vue?vue&type=style&index=0&id=c021e9e6&prod&lang=scss"
import style1 from "./matched.vue?vue&type=style&index=1&id=c021e9e6&prod&lang=scss"
import style2 from "./matched.vue?vue&type=style&index=2&id=c021e9e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports